import FileUpload, {Props as FileUploadProps} from './FileUpload'

export {FileUpload, FileUploadProps}
